"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cypressGet = exports.GraphQLEditorCypress = void 0;
exports.GraphQLEditorCypress = {
    name: 'editor',
    diagram: {
        name: 'diagram',
    },
    code: {
        name: 'code',
    },
    hierarchy: {
        name: 'hierarchy',
    },
    sidebar: {
        name: 'sidebar',
        menu: {
            name: 'menu',
            children: {
                diagram: {
                    name: 'diagram',
                },
                codeDiagram: {
                    name: 'codeDiagram',
                },
                code: {
                    name: 'code',
                },
                hierarchy: {
                    name: 'hierarchy',
                },
            },
        },
        code: {
            name: 'code',
            children: {
                status: {
                    name: 'status',
                },
            },
        },
        explorer: {
            name: 'explorer',
            children: {
                search: {
                    name: 'search',
                },
                filters: {
                    name: 'filters',
                },
                list: {
                    name: 'list',
                },
            },
        },
    },
};
function cypressGet(obj, ...props) {
    let constructString = 'ge';
    obj &&
        props.reduce((result, prop) => {
            constructString = [constructString, prop].join('-');
            return result == null ? undefined : result[prop];
        }, obj);
    return constructString;
}
exports.cypressGet = cypressGet;
